import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { InputLabel, Typography, Unstable_Grid2 as Grid } from '@mui/material';

import { ValidatedTextField } from 'components';
import SlateEditor from 'components/SlateEditor';
import Tip from 'components/Tip';

import Image from './Image';

const styles = {
  subject: {
    fontWeight: 'bold',
    textTransform: 'none',
    color: 'common.black',
    fontSize: 18,
  },
} as const;

const Message: FC = () => {
  const { t } = useTranslation();

  return (
    <Grid container>
      <Grid xs={3}>
        <Typography variant="subtitle2">{t('common:message')}</Typography>
      </Grid>
      <Grid xs={9}>
        <Grid container direction="column" wrap="nowrap" spacing={4}>
          <Grid>
            <InputLabel sx={styles.subject} shrink>{`${t('admin:subject')}:`}</InputLabel>
            <ValidatedTextField
              removeLabel
              name="subject"
              i18nKey="contentEmails:emailSubject"
              color="primary"
              variant="outlined"
              TextFieldProps={{ margin: 'none' }}
            />
            <Tip i18nKey="contentEmails:subjectTip" />
          </Grid>

          <Grid>
            <Image />
          </Grid>

          <Grid>
            <SlateEditor
              fieldName="intro"
              label={t('contentEmails:introMessage')}
              placeholder={t('contentEmails:introMessagePlaceholder')}
            />
            <Tip i18nKey="contentEmails:introMessageTip" />
          </Grid>

          <Grid>
            <SlateEditor
              fieldName="footer"
              label={t('contentEmails:footerMessage')}
              placeholder={t('contentEmails:footerMessagePlaceholder')}
            />
            <Tip i18nKey="contentEmails:footerMessageTip" />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Message;
